import React from 'react'
import { Container, Row } from 'reactstrap'


import VerificationStatus from './VerificationStatus'


export default function PurchaseManager() {
    return (
        <>
            <Container className='manager-card' fluid>
                <Row>
                  
               <VerificationStatus/>
                </Row>
            </Container>
        </>
    )
}